import TokenRepo from './token.repo';
import type { EInvoiceRoutingConfiguration, EInvoiceRoutingOptions, EInvoiceRoutingUpdate } from '../models/einvoice-routing.model';
export class EInvoiceRoutingError extends Error {
  constructor(public readonly status: number, message: string) { super(message); this.name = 'EInvoiceRoutingError'; }
}
export class EInvoiceRoutingRepo {
  constructor(private readonly tokens = new TokenRepo(), private readonly transport: typeof fetch = (...args) => fetch(...args)) {}
  private async request<T>(path: string, body?: object): Promise<T> {
    const token = this.tokens.getToken();
    if (!token) throw new EInvoiceRoutingError(401, 'Phiên đăng nhập đã kết thúc.');
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 15000);
    try {
      const response = await this.transport(`${process.env.REACT_APP_API_URL || ''}/api/EInvoiceRouting/${path}?v=1.0`, {
        method: body === undefined ? 'GET' : 'POST', signal: controller.signal, credentials: 'omit', cache: 'no-store',
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json', ...(process.env.REACT_APP_API_NGROK === 'true' ? {'ngrok-skip-browser-warning': 'true'} : {}) },
        ...(body === undefined ? {} : {body: JSON.stringify(body)}),
      });
      const data = await response.json().catch(() => null);
      if (!response.ok || data?.code !== '00' || data.result == null) {
        throw new EInvoiceRoutingError(response.status, typeof data?.errorMessage === 'string' && data.errorMessage.trim()
          ? data.errorMessage.slice(0, 1000) : response.status === 404 ? 'Máy chủ chưa hỗ trợ nhóm mẫu hóa đơn.' : 'Không tải hoặc cập nhật được nhóm mẫu hóa đơn.');
      }
      return data.result;
    } catch (error) {
      if (error instanceof EInvoiceRoutingError) throw error;
      throw new EInvoiceRoutingError(0, 'Không kết nối được máy chủ. Tải lại nhóm mẫu hóa đơn để kiểm tra kết quả.');
    } finally { clearTimeout(timeout); }
  }
  get() { return this.request<EInvoiceRoutingConfiguration>('configuration'); }
  options() { return this.request<EInvoiceRoutingOptions>('options'); }
  save(input: EInvoiceRoutingUpdate) { return this.request<EInvoiceRoutingConfiguration>('configuration', input); }
  verify(input: {revision: string; groupId: string; year: number}) { return this.request<unknown>('verify', input); }
}
export const eInvoiceRoutingRepo = new EInvoiceRoutingRepo();
